export default "__VITE_ASSET__C_tglx1z__"